import Vue from 'vue'
import Router from 'vue-router'

import Auth from '../components/Auth.vue'
import Enviarbiblioteca from '../components/Enviarbiblioteca.vue'
import Biblioteca from '../components/Biblioteca.vue'
import Completo from '../components/Pedidocompleto.vue'
import Categoria from '../components/Categoria.vue'
import Confirmacionpedido from '../components/Confirmacionpedido.vue'
import Enviarpedido from '../components/Enviarpedido.vue'
import Inicio from '../components/Inicio.vue'
import Informacion from '../components/Informacion.vue'
import Listador from '../components/Listador.vue'
import Login from '../components/Login.vue'
import Pedidos from '../components/Pedidos.vue'
import Pedido from '../components/Pedido.vue'
import Registro from '../components/Registro.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/informacion',
      name: 'Informacion',
      component: Informacion
    },
    {
      path: '/listador/:msg?',
      name: 'Listador',
      component: Listador,
      props: true
    },
    {
      path: '/procesarpedido',
      name: 'Enviar',
      component: Enviarpedido
    },
    {
      path: '/pedidocompleto/:idnuevo/:guardar?',
      name: 'Completo',
      component: Completo,
      props: true
    },
    {
      path: '/pedidos',
      name: 'Pedidos',
      component: Pedidos
    },
    {
      path: '/pedido/:id',
      name: 'Pedido',
      component: Pedido,
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/auth/:usr/cred/:auth',
      name: 'Auth',
      component: Auth,
      props: true
    },
    {
      path: '/confirmacionpedido/:usr/cred/:auth/pedido/:pedido',
      name: 'Confirmacionpedido',
      component: Confirmacionpedido,
      props: true
    },
    {
      path: '/enviarabiblioteca/:pedidolocal',
      name: 'Enviarbiblioteca',
      component: Enviarbiblioteca,
      props: true
    },
    {
      path: '/biblioteca',
      name: 'Biblioteca',
      component: Biblioteca
    },
    {
      path: '/categoria/:slug/:msg?',
      name: 'Categoria',
      component: Categoria,
      props: true
    },
    {
      path: '/registro',
      name: 'Registro',
      component: Registro
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js